export function getProfileIdentifier(user) {
  if (!user || typeof user !== 'object') return '';
  const username = String(user.username || '').trim();
  if (username) return username;
  const userId = String(user.user_id || '').trim();
  return userId;
}

export function buildProfilePath(user) {
  const identifier = typeof user === 'string' ? user.trim() : getProfileIdentifier(user);
  if (!identifier) return '/profile';
  return `/profile/${encodeURIComponent(identifier)}`;
}

export function matchesProfileIdentifier(user, identifier) {
  const normalizedIdentifier = String(identifier || '').trim().toLowerCase();
  if (!user || !normalizedIdentifier) return false;
  const userId = String(user.user_id || '').trim().toLowerCase();
  const username = String(user.username || '').trim().toLowerCase();
  return normalizedIdentifier === userId || normalizedIdentifier === username;
}
